import MaskedInput from "react-text-mask";

export const CPFMask = ({ value, onChange, disabled, error }) => {
  const cpfMask = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];

  return (
    <div className="form-group">
      <label htmlFor="documentNumber">CPF:</label>
      <MaskedInput
        mask={cpfMask}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={error ? 'invalid' : ''}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
